import { Divider, Icon } from 'antd';
import React from 'react';

function isDataURI(imgURI: string) {
    return imgURI.split(':')[0] === 'data';
}

type Props = {
    logo?: string;
    header?: string;
};

export default function TemplateHeader({ logo, header }: Props) {
    return (
        <div className="header-container flexbox align-center">
            <div className="template-logo">
                <div className="step-counter flexbox align-center justify-center">1</div>
                {logo ? (
                    <img
                        className="logo-img"
                        src={isDataURI(logo) ? logo : `${logo}?${new Date().getTime()}`}
                        alt="logo"
                    />
                ) : (
                    <Icon type="picture" />
                )}
            </div>
            <Divider
                type="vertical"
                style={{ width: '2px' }}
            />
            <div className="template-header">
                <div className="step-counter flexbox align-center justify-center">2</div>
                <span>{header ? header : 'Sample text in the header'}</span>
            </div>
        </div>
    );
}
